export const webview = {
  TeaAndSnacks: (EmpId, UserName) => `https://gnn.gatewaydigital.ai/canteen/?uid=${EmpId}&uname=${UserName}`,
  Feedback: 'https://forums.gatewaydigital.ai/login',
  Leave: {
    MyLeave: (TOKEN) =>
      `https://gis.thegatewaycorp.com/Open/WebView.aspx?AuthKey=${TOKEN}&IsLeave=1&IsLoginThroughMobile=1`,
    MyWFH: (TOKEN) =>
      `https://gis.thegatewaycorp.com/Open/WebView.aspx?AuthKey=${TOKEN}&IsWFH=1&IsLoginThroughMobile=1`,
    MyOOF: (TOKEN) =>
      `https://gis.thegatewaycorp.com/Open/WebView.aspx?AuthKey=${TOKEN}&IsOOW=1&IsLoginThroughMobile=1`,
  },
  ApprovalPM: {
    LeaveApproval: (TOKEN) =>
      `https://gis.thegatewaycorp.com/Open/WebView.aspx?AuthKey=${TOKEN}&IsLeaveApproval=1&IsLoginThroughMobile=1`,
    WFHApproval: (TOKEN) =>
      `https://gis.thegatewaycorp.com/Open/WebView.aspx?AuthKey=${TOKEN}&IsWFHApproval=1&IsLoginThroughMobile=1`,
    OOFApproval: (TOKEN) =>
      `https://gis.thegatewaycorp.com/Open/WebView.aspx?AuthKey=${TOKEN}&IsOOWApproval=1&IsLoginThroughMobile=1`,
  },
  // Connect: 'https://connect.thegatewaycorp.com/',
  Connect:{ResumeX:(userName,password)=>`https://connect.thegatewaycorp.com/employee-login?username=${userName}&password=${password}`},
  GPTs: 'https://gpts.gatewaydigital.ai/',
  ConferenceRoomBooking:
    'http://10.0.0.250/Web/index.php?redirect=%2FWeb%2Freservation.php%3Frid%3D20%26sid%3D1%26rd%3D2024-01-05%26sd%3D2024-01-05%252011%253A00%253A00%26ed%3D2024-01-05%252021%253A30%253A00',
  Holidays: 'leave module close',
  Gatepass: URL,
  // TD_Reimbursement: `https://develop.gnxt.vaanilabs.ai/staging/expense/linkway`,
  // TD_Reimbursement: `http://10.0.2.151:3030/staging/expense/linkway`,
  // TD_Reimbursement: `https://yemo.ai/staging/expense`,
  TD_Reimbursement: process.env.REACT_APP_REIMBURSEMENT_URL,
  Meetingplatform: `https://meeting.thegatewaycorp.com/`,
  Travel_desk: URL,
  ResumeX: URL,
};
